<template>
  <Transition name="el-fade-in">
    <div
      v-show="show"
      class="card raised"
      :class="[
        cardTypeClassname,
        {
          'card--bordered': bordered,
          'card--hide-overflow': hideOverflow,
          'card--no-padding': noPadding,
          'card--scrollable': scrollable,
          'card--no-margin': noMargin,
        },
      ]"
    >
      <div v-if="!isLoading" class="card__block">
        <slot />
      </div>
      <div v-else class="card__block card__block--loading">
        <HollowDotsSpinner
          :animation-duration="1000"
          :dot-size="12"
          :dots-num="3"
          :color="'#95a5a6'"
        />
      </div>
    </div>
  </Transition>
</template>
<script>
import HollowDotsSpinner from './HollowDotsSpinner';

export default {
  name: 'Card',
  components: {
    HollowDotsSpinner,
  },
  props: {
    isLoading: {
      default: false,
      type: Boolean,
    },
    show: {
      default: true,
      type: Boolean,
    },
    type: {
      validator(value) {
        return ['danger', 'success', ''].includes(value);
      },
      default: '',
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    hideOverflow: {
      default: true,
      type: Boolean,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardTypeClassname() {
      if (this.type === 'success') return 'card--success';
      else if (this.type === 'danger') return 'card--danger';
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  $base: &;

  max-width: 100%;
  margin-top: $global-margin;
  margin-bottom: $global-margin;
  padding-top: $global-padding;
  padding-bottom: $global-padding;
  background-color: #fff;

  &--hide-overflow {
    overflow: hidden;
  }

  &__block {
    padding: $global-padding $global-padding;
    position: relative;
    width: 100%;
    max-width: 100%;
    height: 100%;

    @include breakpoint(large) {
      padding-left: $global-padding * 2;
      padding-right: $global-padding * 2;
    }

    &--loading {
      padding-top: $global-padding * 2;
      padding-bottom: $global-padding * 2;
      display: flex;
      justify-content: center;
    }
  }

  &__header {
    padding-bottom: $global-padding;
  }

  &__title {
    text-align: center;
  }

  &--has-header {
    padding-top: 0;
  }

  &--scrollable {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;

    #{$base}__block {
      display: inline-block;
      vertical-align: top;
    }
  }

  &--bordered {
    border-right: 0;
    border-left-width: 3px;
    border-left-style: solid;

    @include rtl() {
      border-right-width: 3px;
      border-right-style: solid;
      border-left: 0;
    }
  }

  &--success {
    border-color: $lb-color-success;
  }

  &--danger {
    border-color: $lb-color-alert;
  }

  &--no-padding {
    padding: 0;

    #{$base}__block:not(#{$base}__block--loading) {
      padding: 0;
    }
  }

  &--no-margin {
    margin: 0;
  }
}
</style>
